export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exporter"])},
        "no_offers_to_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune offre à exporter"])}
      },
      "en": {
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export"])},
        "no_offers_to_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No offers to export"])}
      }
    }
  })
}
